import { Component, Input } from '@angular/core';
import { CallInfo } from '@salesforce/scv-connector-base';

@Component({
  selector: 'app-active-call-info',
  templateUrl: './active-call-info.component.html',
  styleUrls: ['./active-call-info.component.css']
})
export class ActiveCallInfoComponent {
  @Input() callInfo?: CallInfo;

  stringifyAdditionalFields(): string {
    return JSON.stringify(this.callInfo?.additionalFields);
  }
}
